import {getTeams, updateTeam, deleteTeam, addMembers, deleteMembers, addManagers, deleteManagers} from '@/api/team';
import { v4 as uuidv4 } from 'uuid';
import { AccountModule, getPermissionNames } from '@/store/modules/account';
import moment from 'moment';
import { companyAllActiveUser } from '@/utils/user';


type ITeamInfo = ITeam.IResponse.ITeamInfo;
type IUpdateTeamInfo = ITeam.IRequest.ITeamInfo;

interface ITableTeamInfo extends ITeamInfo {
  hasEditPermission: boolean;
}

interface ITeamManage {
  data: ITeamInfo[];
  editData: {
    teamInfo: ITeamInfo | null;
    isCreate: boolean;
  };
  // defaultParams: ITeam.IRequest.IGetTeams;
  isMore: boolean;
  requestGetTeams(): Promise<string>;
  requestGetMoreTeams(): Promise<string>;
  requestUpdateTeam(params: IUpdateTeamInfo): Promise<string>;
  requestDeleteTeam(TeamId: string): Promise<string>;
  requestAddMembers(params: string[]): Promise<string>;
  requestDeleteMembers(params: string[]): Promise<string>;
  createTeam(): void;
  editTeam(Team: ITeamInfo): void;
  updateTeamList(params: IUpdateTeamInfo): void;
  addTeam(team: ITeamInfo): void;
  updateTeam(team: ITeamInfo): void;
  removeTeam(teamId: string): void;
  addTeamMembers(memberIds: string[]): void;
  removeTeamMembers(memberIds: string[]): void;
  updateIsMore(length: number): void;
}

export class TeamManage implements ITeamManage {
  private $data: ITeamInfo[] = [];
  private $editData: {
    teamInfo: ITeamInfo | null;
    isCreate: boolean;
  } = {
    teamInfo: null,
    isCreate: false,
  };
  private $defaultParams: ITeam.IRequest.IGetTeams = {
    pagesize: 20,
    pageindex: 1,
    returnMember: true,
    returnProject: true,
  };
  private $isMore = false;
  get data() {
    return this.$data;
  }
  get editData() {
    return this.$editData;
  }
  get isMore() {
    return this.$isMore;
  }
  get tableData(): ITableTeamInfo[] {
    return enrichTeamInfo(this.$data);
  }
  public requestGetTeams(): Promise<string> {
    this.$defaultParams = {
      returnMember: true,
      returnProject: true,
      pageindex: 1,
      pagesize: 20,
    };
    return new Promise((resolve, reject) => {
      getTeams(this.$defaultParams).then((res) => {
        this.$data = res.data;
        this.updateIsMore(res.data.length);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestGetMoreTeams(): Promise<string> {
    return new Promise((resolve, reject) => {
      const pageIndex = this.$defaultParams.pageindex || 1;
      this.$defaultParams.pageindex = pageIndex + 1;
      getTeams(this.$defaultParams).then((res) => {
        this.$data = this.$data.concat(res.data);
        this.updateIsMore(res.data.length);
        resolve(res.message);
      }).catch((err) => {
        reject(err);
      });
    });
  }
  public requestTeamInfoById(teamId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      getTeams({
        id: teamId,
      }).then((res) => {
        if (res.data.length > 0) {
          this.updateTeam(res.data[0]);
          resolve(res.message);
        } else {
          reject('暫無數據');
        }
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestUpdateTeam(params: IUpdateTeamInfo): Promise<string> {
    return new Promise((resolve, reject) => {
      updateTeam({
        teamId: this.$editData.teamInfo!.id,
        data: params,
      }).then((res) => {
        this.updateTeamList(params);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestDeleteTeam(teamId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      deleteTeam(teamId).then((res) => {
        this.removeTeam(teamId);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestAddMembers(memberIds: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      addMembers({
        teamId: this.$editData.teamInfo!.id,
        memberIds,
      }).then((res) => {
        this.addTeamMembers(memberIds);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestDeleteMembers(memberIds: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      deleteMembers({
        teamId: this.$editData.teamInfo!.id,
        memberIds,
      }).then((res) => {
        this.removeTeamMembers(memberIds);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestAddManagers(managerIds: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      addManagers({
        teamId: this.$editData.teamInfo!.id,
        managerIds,
      }).then((res) => {
        this.addManagers(managerIds);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestDeleteManagers(managerIds: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      deleteManagers({
        teamId: this.$editData.teamInfo!.id,
        managerIds,
      }).then((res) => {
        this.removeManagers(managerIds);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public createTeam() {
    this.$editData = {
      teamInfo: {
        id: uuidv4(),
        name: '',
        comment: '',
        createdName: '',
        createdOn: '',
        createdBy: '',
        leader: '',
        leaderName: '',
        members: [],
        projects: [],
        manager: [],
        active: true,
      },
      isCreate: true,
    };
  }
  public editTeam(teamInfo: ITeamInfo) {
    this.$editData = {
      teamInfo: {...teamInfo},
      isCreate: false,
    };
  }
  public addTeam(teamInfo: ITeamInfo) {
    this.$data.unshift(teamInfo);
  }
  public updateTeam(teamInfo: ITeamInfo) {
    for (const teamItem of this.$data) {
      if (teamItem.id === teamInfo.id) {
        Object.assign(teamItem, teamInfo);
        break;
      }
    }
  }
  public updateTeamList(team: IUpdateTeamInfo) {
    const newUser = companyAllActiveUser.find((user) => user.id === team.leader);
    const newTeam: ITeamInfo = {
      id: this.$editData.teamInfo!.id,
      name: team.name,
      comment: team.comment,
      leader: team.leader,
      leaderName: newUser?.name || '',
      active: team.active,
      createdName: this.$editData.teamInfo?.createdName || AccountModule.name,
      createdOn: this.$editData.teamInfo?.createdOn || moment().toJSON(),
      createdBy: this.$editData.teamInfo?.createdBy || AccountModule.userDetailInfo?.id || '',
      members: this.$editData.teamInfo?.members || [],
      manager: this.$editData.teamInfo?.manager || [],
      projects: this.$editData.teamInfo!.projects,
    };
    if (this.$editData.isCreate) {
      this.addTeam(newTeam);
    } else {
      this.updateTeam(newTeam);
    }
  }
  public removeTeam(teamId: string) {
    const index = this.$data.findIndex((team) => team.id === teamId);
    this.$data.splice(index, 1);
  }
  public addTeamMembers(memberIds: string[]) {
    const teamId = this.$editData.teamInfo!.id;
    const newMembers = companyAllActiveUser.filter((user) => memberIds.includes(user.id));
    for (const team of this.$data) {
      if (team.id === teamId) {
        team.members = team.members.concat(newMembers);
        break;
      }
    }
  }
  public removeTeamMembers(memberIds: string[]) {
    const teamId = this.$editData.teamInfo!.id;
    const newMembers = this.$editData.teamInfo!.members.filter((user) => !memberIds.includes(user.id));
    for (const team of this.$data) {
      if (team.id === teamId) {
        team.members = newMembers;
        break;
      }
    }
  }
  public addManagers(managerIds: string[]) {
    const teamId = this.$editData.teamInfo!.id;
    const newManagers = companyAllActiveUser.filter((user) => managerIds.includes(user.id));
    for (const team of this.$data) {
      if (team.id === teamId) {
        team.manager = team.manager.concat(newManagers);
        break;
      }
    }
  }
  public removeManagers(managerIds: string[]) {
    const teamId = this.$editData.teamInfo!.id;
    const newManagers = this.$editData.teamInfo!.manager.filter((user) => !managerIds.includes(user.id));
    for (const team of this.$data) {
      if (team.id === teamId) {
        team.manager = newManagers;
        break;
      }
    }
  }
  public updateIsMore(length: number) {
    if (length < this.$defaultParams.pagesize!) {
      this.$isMore = false;
    } else {
      this.$isMore = true;
    }
  }
  public clearData() {
    this.$data.length = 0;
  }
}
const hasEditPermission = (team: ITeamInfo, permissionNames: string[]) => {
  let editAll = false;
  if (permissionNames.includes('Team_Edit_All')) {
    editAll = true;
    return editAll;
  }
  let editAdmin = false;
  if (permissionNames.includes('Team_Edit_Admin')) {
    editAdmin = team.manager.some((manager) => manager.id === AccountModule.userDetailInfo?.id);
  }
  let editLeader = false;
  if (permissionNames.includes('Team_Edit_Leader')) {
    editLeader = team.leader === AccountModule.userDetailInfo?.id;
  }
  let editOwn = false;
  if (permissionNames.includes('Team_Edit_Own')) {
    editOwn = team.createdBy === AccountModule.userDetailInfo?.id;
  }
  return editAdmin || editLeader || editOwn;
};
const enrichTeamInfo = (teamList: ITeamInfo[]): ITableTeamInfo[] => {
  const result: ITableTeamInfo[] = [];
  for (const team of teamList) {
    result.push({
      ...team,
      hasEditPermission: hasEditPermission(team, getPermissionNames()),
    });
  }
  return result;
};
export const teamManage = new TeamManage();
